import type { SVGProps } from 'react';
export const Logo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 158" {...props}>
    <mask id="a" fill="#fff">
      <path fillRule="evenodd" d="M0 0h12.234v16H0z" />
    </mask>
    <mask id="b" fill="#fff">
      <path fillRule="evenodd" d="M0 0h9.333v1.766H0z" />
    </mask>
    <mask id="c" fill="#fff">
      <path fillRule="evenodd" d="M0 0h31.458v92.333H0z" />
    </mask>
    <g fill="none">
      <path
        fill="currentColor"
        d="M13.518 62.563V28.272h31.77v34.291h19.397v24.25H45.289v29.271c0 8.5 2.396 12.75 7.187 12.75 1.193 0 2.448-.234 3.771-.708 1.318-.485 2.339-.969 3.063-1.459l1.062-.708 7.917 25.667c-6.833 3.833-14.62 5.75-23.354 5.75-5.99 0-11.136-1.042-15.438-3.125-4.307-2.094-7.573-4.906-9.791-8.438-2.209-3.541-3.792-7.255-4.75-11.146-.959-3.885-1.438-8.046-1.438-12.479V86.813H.226v-24.25zM124.995 143.292c-8.615-9.4-12.917-20.921-12.917-34.562 0-13.651 4.302-25.208 12.917-34.667 8.625-9.458 19.583-14.187 32.875-14.187 12.208 0 22.26 3.833 30.167 11.5v-8.813h31.791v92.125h-31.437v-10.416h-.354c-7.907 8.74-17.959 13.104-30.167 13.104-13.292 0-24.25-4.693-32.875-14.084zm27.042-50.187c-4.125 4.073-6.188 9.281-6.188 15.625 0 6.333 1.969 11.51 5.917 15.52 3.943 4.016 9.15 6.022 15.625 6.022 6.219 0 11.338-2.032 15.354-6.105 4.01-4.067 6.02-9.213 6.02-15.437 0-6.344-2.072-11.552-6.207-15.625-4.125-4.068-9.183-6.104-15.167-6.104-6.115 0-11.23 2.036-15.354 6.104z"
      />
      <g fill="#a77fdb">
        <path d="M80.354 32.344c-2.755-2.667-7.047-6.23-11.984-5.73-.198-.89 2.495-1.062 3.031-1.479 1.599-.567 2.99-1.5 4.443-2.354 5.958-4.604 8.4-12.37 8.812-19.62-.307-6.322 3.714 15.6 11.11 18.756 1.979 1.297 4.135 2.213 6.286 3.099 2.25.609 4.412.895.453 1.349-10.02 2.62-15.026 11.817-15.791 22.26-.818 2.62-1.198-6.396-1.829-7.526-1.026-3.255-2.421-6.38-4.53-8.755z" />
        <path
          d="M5.688 15.125c-1.38-1.286-1.016-4.917-3.027-6.37C2.057 8.11.057 7.875-.005 7.1 5.28 5.885 4.91-2.958 5.839 1.557c.5 2.683 2.817 4.433 5.234 5.407 3.786 1.276-4.563-.224-5.386 8.161z"
          mask="url(#a)"
          transform="translate(59.766 2)"
        />
        <path
          d="M4.24 1.125C3.677-4.552-1.1-2.443 2.828-4.885c1.453-1.464.922-3.224 1.589-2.75.156 2.156 2.026 3.375 3.849 4.099-2 .484-3.47 2.656-4.026 4.661z"
          mask="url(#b)"
          transform="translate(69.333 .234)"
        />
        <path d="M102.005 43.74c-.442-1.896-.953-4.058-3.104-4.605-.213-.072-.167-.265.037-.328 2.099-.26 2.322-3.286 3.224-3.911-.047 2.432 2.656 3.344 3.848 4.396-2.479.057-3.276 2.823-4.005 4.448z" />
      </g>
      <path
        fill="currentColor"
        d="M0 0h31.458v92.292H0z"
        mask="url(#c)"
        transform="translate(71.802 63.802)"
      />
    </g>
  </svg>
);
